import { type Insets } from '../render/viewport';

const RESIZE_SETTLE_MS = 120;

/** Reads the HUD clearance the stylesheet declares on a stage (`--safe-top` etc., in px). */
export function readSafeArea(stage: Element): Insets {
  const style = getComputedStyle(stage);
  const px = (name: string): number => parseFloat(style.getPropertyValue(name)) || 0;
  return {
    top: px('--safe-top'),
    right: px('--safe-right'),
    bottom: px('--safe-bottom'),
    left: px('--safe-left'),
  };
}

/** Re-baking the city on every resize event is too slow; wait until the window settles. */
export function watchResize(layout: () => void): () => void {
  let timer = 0;
  const onResize = (): void => {
    window.clearTimeout(timer);
    timer = window.setTimeout(layout, RESIZE_SETTLE_MS);
  };
  window.addEventListener('resize', onResize);
  return () => {
    window.clearTimeout(timer);
    window.removeEventListener('resize', onResize);
  };
}
